import React, { useEffect } from "react"
import { useParams } from "react-router-dom"
import UpdateOutstationForm from "./UpdateOutstationForm"
import UpdateLocalForm from "./UpdateLocalForm"
import UpdateRentalForm from "./UpdateRentalForm"

const UpdateCabForm = () => {
  const [tripType, setTripType] = React.useState(null)
  const params = useParams()

  // Function to update trip type from localStorage
  const updateTripType = () => {
    const tripData = localStorage.getItem("tripData")
    if (tripData) {
      const parsedData = JSON.parse(tripData)
      setTripType(parsedData.trip_type)
    }
  }

  useEffect(() => {
    updateTripType()
    
    // Listen for storage events (when localStorage is updated by other components)
    const handleStorageChange = () => {
      updateTripType()
    }
    
    window.addEventListener('storage', handleStorageChange)
    
    // Also listen for custom storage event (for same-window updates)
    window.addEventListener('tripDataUpdated', handleStorageChange)
    
    return () => {
      window.removeEventListener('storage', handleStorageChange)
      window.removeEventListener('tripDataUpdated', handleStorageChange)
    }
  }, [params.fromCity, params.toCity]) // Re-check when route params change

  return (
    <div className="updateCabForm">
      {tripType === 3 && (
        <UpdateOutstationForm />
      )}
      {tripType === 2 && (
        <UpdateRentalForm />
      )}
      {tripType === 1 && (
        <UpdateLocalForm />
      )}
    </div>
  )
}

export default UpdateCabForm
